import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from './Continuation.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompletedContinuationClass;
function CompletedContinuation() {
  if (CompletedContinuationClass === VOID) {
    class $ {
      pc() {
        // Inline function 'kotlin.error' call
        var message = 'This continuation is already complete';
        throw IllegalStateException().o(toString(message));
      }
      qc(result) {
        // Inline function 'kotlin.error' call
        var message = 'This continuation is already complete';
        throw IllegalStateException().o(toString(message));
      }
      rc(result) {
        return this.qc(result);
      }
      toString() {
        return 'This continuation is already complete';
      }
    }
    initMetadataForObject($, 'CompletedContinuation', VOID, VOID, [Continuation()]);
    CompletedContinuationClass = $;
  }
  return CompletedContinuationClass;
}
var CompletedContinuation_instance;
function CompletedContinuation_getInstance() {
  return CompletedContinuation_instance;
}
//region block: init
CompletedContinuation_instance = new (CompletedContinuation())();
//endregion
//region block: exports
export {
  CompletedContinuation_instance as CompletedContinuation_instance1efj83g4cxe0q,
};
//endregion

//# sourceMappingURL=CoroutineImpl.mjs.map
